exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".last-edit {\n    margin: 30px 0;\n}\n\n.last-edit--title {\n    font-size: 12px;\n    font-weight: normal;\n    color: #777;\n    margin-bottom: 21px;\n    display: block;\n}\n\n.last-edit--info {\n    font-size: 14px;\n    margin-bottom: 7px;\n}\n\n.last-edit--info_solid {\n    color: #000;\n    padding-bottom: 10px;\n}\n\n.last-edit--link {\n    cursor: pointer;\n    font-size: 12px;\n    line-height: 1.5;\n    color: #542376;\n    text-decoration: none;\n    margin-top: 11px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1}!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/lastEdit/last-edit.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/lastEdit/last-edit.css
// module chunks = 0